//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productUnit', {
//        templateUrl: 'views/components/views/productUnit/productUnit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'utilityService', 'modalService', 'productUnitService', function ($stateParams, stateService, translateService, utilityService, modalService, productUnitService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodId = $stateParams.prod_id;
//            let productUnitKeyno = $stateParams.productunit_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListNewProductUnits: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await productUnitService.getProductUnit({
//                    prod_id: prodId,
//                    productunit_keyno: productUnitKeyno
//                }))[0];
//            }
            
//            async function loadNewProductUnits() {
//                if (utilityService.validateParmsValue(vm.model.edit.prod_id) !== true) return;

//                vm.model.selectListNewProductUnits = await productUnitService.listNewProductUnits({ prod_id: vm.model.edit.prod_id });
//            }

//            // #endregion PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE FUNCTION

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                productUnitService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE FUNCTION

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    productUnitService.deleteItem(vm.model.edit).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadNewProductUnits();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
